import { PrinterDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { EventTemplatesDataResolver } from '../../../resolvers/event-template-data.resolver';
import { TemplatesCreateSchedulesCreateFormsView } from './forms/forms';

export const TemplatesCreateSchedulesCreateView = angular
  .module('acme.view.application.templates.create.schedules.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.view.application.templates.create.schedules.create.controllers',
    'acme.view.application.templates.create.schedules.create.times',
    'acme.view.application.templates.create.schedules.create.pricing',
    'acme.view.application.templates.create.schedules.create.resources',
    'acme.view.application.templates.create.schedules.create.tickets',
    TemplatesCreateSchedulesCreateFormsView,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.schedules.create',
      url: '',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateSchedulesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.create',
      url: '',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateSchedulesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
      resolve: {
        EventTemplateData: EventTemplatesDataResolver({ noCache: true }),
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.edit',
      url: '/:scheduleId',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateSchedulesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
      resolve: {
        EventTemplateData: EventTemplatesDataResolver({ noCache: true }),
        PrinterData: PrinterDataResolver(),
      },
    });
  }).name;
